import * as React from 'react';
import { SummaryDesktop } from './SummaryDesktop';
import { withProvider } from '../../redux';
import { ApplicationContext } from '../ApplicationContext';
import { ISummaryDesktopContainerProps } from './types';
import { useIsMobileDevice } from '../../hooks';
import { useSelector } from 'react-redux';
import { selectIsIdentificationNeeded, selectIsPublishToHiddenBase } from '../../selectors/publishAvailable';
import { NeedIdentificationDesktop } from '../NeedIdentificationDesktop';
import { HiddenBaseDesktop } from '../HiddenBaseDesktop';

export const Container = () => {
  const isMobile = useIsMobileDevice();

  const isIdentificationNeeded = useSelector(selectIsIdentificationNeeded);
  const isPublishToHiddenBase = useSelector(selectIsPublishToHiddenBase);

  if (isMobile) {
    return null;
  }

  if (isIdentificationNeeded) {
    return <NeedIdentificationDesktop />;
  }

  if (isPublishToHiddenBase) {
    return <HiddenBaseDesktop />;
  }

  return <SummaryDesktop />;
};

export const SummaryDesktopContainer = withProvider(({ httpApi, logger, config }: ISummaryDesktopContainerProps) => {
  const context = { httpApi, logger, config };

  return (
    <ApplicationContext.Provider value={context}>
      <Container />
    </ApplicationContext.Provider>
  );
});
